export default __webpack_public_path__ + "static/media/lumin33store.b9bffbb3.png";